import { utilityApi } from 'yxt-biz-pc/packages/api';

export const getAreas = () => {
  return utilityApi.get('regions/tree', { locale: 'zh_CN' });
};
